import { useEffect, useState } from 'react';
import './App.css';
import contract from './contracts/NFTCollectible.json';
import { ethers } from 'ethers';

const contractAddress = "0xd9C1c47c3Ccf1B2c882dEA3C28b976aF7727149A";
const abi = contract.abi;

const App = () => {

    const [currentAccount, setCurrentAccount] = useState(null);
    const pleaseConnect = ("<span style=\"font-size:48px\">Please make sure MetaMask is installed!</span></br></br>");

    const { ethereum } = window;
    if (ethereum) {
        const _provider = new ethers.providers.Web3Provider(window.ethereum, "any");
        _provider.on("network", (newNetwork, oldNetwork) => {
            // When a Provider makes its initial connection, it emits a "network"
            // event with a null oldNetwork along with the newNetwork. So, if the
            // oldNetwork exists, it represents a changing network
            if (oldNetwork) {
                window.location.reload();
            }
            //console.log(newNetwork);
        });
        var signer = _provider.getSigner();
        var _nftContract = new ethers.Contract(contractAddress, abi, signer);

        var mintFigure = 0;

        mintFigures();
    }

    async function mintFigures() {
        console.log(_nftContract);
        mintFigure = await _nftContract.totalSupply();
        let nftPrice = await _nftContract.PRICE();
        nftPrice = nftPrice / 1000000000000000000;
        document.getElementById("price").innerHTML = ("<h2>"+nftPrice + " $MATIC Each!</h2><br><br>");
        document.getElementById("progress").innerHTML = ("<h2>" + mintFigure + "/1444 Minted!</h2>");
    }

    //var curNetwork = provider.getNetwork();
    //var netName = curNetwork.name;

    const checkWalletIsConnected = async () => {
        //ethereum = window;

        if (!ethereum) {
            document.getElementById("main-app").innerHTML = pleaseConnect;
            return;
        } else {
            console.log("Wallet exists! We're ready to go!")
        }
        const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
        const signer = provider.getSigner();
        const nftContract = new ethers.Contract(contractAddress, abi, signer);

        const accounts = await ethereum.request({ method: 'eth_accounts' });
        var curNetwork = await provider.getNetwork();
        var contractLink = "";
        console.log(curNetwork);

        var accShort = "";

        contractLink = ("https://polygonscan.com/address/" + contractAddress);

        if (accounts.length !== 0) {
            const account = accounts[0];
            console.log("Found an authorized account: ", account);
            setCurrentAccount(account);
            accShort = account.slice(0, 5) + "..." + account.slice(account.length - 3);

            //document.getElementById("menu").innerHTML = ("Connected to " + netName + " with address: " + accShort);
            document.getElementById("contract").innerHTML = ("Contract Address: <a href=" + contractLink + ">" + contractAddress + "</a>");


        } else {
            console.log("No authorized account found");
        }

        //document.getElementById("menu").innerHTML = ("Connected to " + netName + " with address: " + accShort);
    }

    function Get(yourUrl) {
        var Httpreq = new XMLHttpRequest(); // a new request
        Httpreq.open("GET", yourUrl, false);
        Httpreq.send(null);
        var fixedURI = Httpreq.responseText.replace();
        return Httpreq.responseText;
    }

    function convertDateToUTC(date) {
        return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    }

    const connectWalletHandler = async () => {
        //const { ethereum } = window;
        if (!ethereum) {
            document.getElementById("main-app").innerHTML = pleaseConnect;
            return;
        } else {
            console.log("Wallet exists! We're ready to go!")
        }

        const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
        const signer = provider.getSigner();
        const nftContract = new ethers.Contract(contractAddress, abi, signer);

        var curNetwork = await provider.getNetwork();
        //var netID = curNetwork.chainId;
        //var netName = getNetName(netID);
        var accShort = "";

        try {
            const accounts = await ethereum.request({ method: 'eth_requestAccounts' });
            console.log("Found an account! Address: ", accounts[0]);
            setCurrentAccount(accounts[0]);
            accShort = accounts[0].slice(0, 5) + "..." + accounts[0].slice(accounts[0].length - 3);

        } catch (err) {
            console.log(err)
        }
    }


    const mintNftHandler = async () => {
        try {
            //const { ethereum } = window;

            if (ethereum) {
                const provider = new ethers.providers.Web3Provider(ethereum);
                const signer = provider.getSigner();
                const nftContract = new ethers.Contract(contractAddress, abi, signer);

                var curNetwork = await provider.getNetwork();
                var netName = curNetwork.name;
                if (netName == "matic") {
                    console.log("testicles");
                    var dropDown = document.getElementById("num");
                    var mintNum = dropDown.value;
                    console.log(mintNum);
                    let nftPrice = await nftContract.PRICE();
                    nftPrice = nftPrice / 1000000000000000000 * mintNum;
                    document.getElementById("log").innerHTML = ("Initialise payment...<br>" + document.getElementById("log").innerHTML);               
                    let nftTxn = await nftContract.mintNFTs(mintNum, { maxFeePerGas: String(40000000000), maxPriorityFeePerGas: String(35000000000), gasLimit: String(300000), value: ethers.utils.parseEther(nftPrice.toString()) });
                    console.log("Hmm...");
                    document.getElementById("log").innerHTML = ("Waiting for transaction...<br>" + document.getElementById("log").innerHTML);
                    await nftTxn.wait();

                    document.getElementById("log").innerHTML = ("Success! See transaction <a href='https://mumbai.polygonscan.com/tx/" + nftTxn.hash + "' >here.</a><br>" + document.getElementById("log").innerHTML);

                    //for (let i = 0; i < 4; i++) {
                    //await nftContract.reserveNFTs();
                    //}
                } else {
                    document.getElementById("demo").innerHTML = "<div style='color:red;'> Please make sure you are connected to the Polygon Network!</div>";
                }
            } else {
                console.log("Ethereum object does not exist");
            }

        } catch (err) {
            if (err.data != null) {
                document.getElementById("demo").innerHTML = err.data.message;
            }

        }

    }
    const connectWalletButton = () => {
        return (
            <button onClick={connectWalletHandler} className='cta-button connect-wallet-button'>
                Connect Wallet
            </button>
        )
    }
    function reloadWindow() {
        console.log("Reload...");
        window.location.href = "https://google.co.uk";
    };

    const mintNftButton = () => {

        // Set the date we're counting down to
        var countDownDate = new Date("Mar 06, 2022 21:00:00");
        console.log(countDownDate);
        //countDownDate = convertDateToUTC(countDownDate);
        //countDownDate = new Date(countDownDate);
        console.log(countDownDate);
        var diStart = -1;

        // Update the count down every 1 second
        var xt = setInterval(function () {

            // Get today's date and time
            var now = new Date();
            now = convertDateToUTC(now);
            //console.log(now);

            // Find the distance between now and the count down date
            var distance = countDownDate - now;

            // Time calculations for days, hours, minutes and seconds
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            // Output the result in an element with id="demo"
            diStart = distance + 2;

            if (distance >= 0) {
                document.getElementById("demo").innerHTML = ("<h1>" + days + "d" + hours + "h" + minutes + "m" + seconds + "s </h1>");
            }
            else if (diStart >= 0) {
                //reloadWindow();
                clearInterval();
                window.location.reload();
                return false;
            } else {
                clearInterval();
                return false;
            }
        }, 10);
        return (
            <button onClick={mintNftHandler} className='cta-button mint-nft-button'>
                Mint NFT
            </button>
        )



    }






    useEffect(() => {
        checkWalletIsConnected();
    }, [])



    return (
        <div className='main-app'>
            <h1>My Little Oni Mint</h1>
            
            <div id="price">...</div>
            <img src="./oni preview.gif" id="gif"></img><br></br><br></br>
            <div id="main-app">
            <label htmlFor="num">How many to mint:</label>
            <select id="num" name="num">
                <option defaultValue="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
            </select><br></br><br></br>
            <div id="demo">
                {currentAccount ? mintNftButton() : connectWalletButton()}
            </div><br></br>
                <div id="progress"></div>
            </div>

            <hr></hr><div id="contract"></div><hr></hr><br></br>
            Debug:<div id="log"></div><br></br>
            <h2>About</h2>
            <p>The Oni are a fierce and greedy lot. Offer them a little $MATIC and they'll fight wars on your behalf. Or,
                rather, they'll bully some Fiendish Friends into fighting for you. The 1444 My Little Oni are paid mercenary leaders from the
                first circle of Crypto Heck. Their services will be invaluable inside the Crypto Heck Tower; an upcoming P2E RPG with multiple ways
to earn.            </p><br></br>

            
        </div>
    )
}

export default App;